@use "../../../globals/bcp";

$element-gap: bcp.size(8);

bcp-product-action-container {
  display: flex;
  flex-direction: column;
  height: 100%;

  .product-action {
    &__price-container {
      margin-bottom: bcp.size(16);
      flex-grow: 1;
    }

    &__quantity-updater-container {
      .product-details {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: $element-gap;

        & > * {
          flex: 1;
        }
      }
    }

    &__action-buttons-container {
      .product-details {
        display: flex;
        flex-direction: column-reverse;
        justify-content: space-between;
        gap: $element-gap;
      }

      &--grid {
        .product-details {
          flex-direction: row-reverse;
          flex-wrap: wrap;

          & > * {
            width: calc(50% - $element-gap / 2);
          }
        }
      }
    }
  }
}
